import { render, staticRenderFns } from "./productMasterRow.vue?vue&type=template&id=08413e87&scoped=true&"
import script from "./productMasterRow.vue?vue&type=script&lang=js&"
export * from "./productMasterRow.vue?vue&type=script&lang=js&"
import style0 from "./productMasterRow.vue?vue&type=style&index=0&lang=css&"
import style1 from "./productMasterRow.vue?vue&type=style&index=1&id=08413e87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08413e87",
  null
  
)

/* custom blocks */
import block0 from "./productMasterRow.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports